module.exports = __webpack_public_path__ + "img/Tut_TapMap.d38a6aa8.png";